'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var link = require('@alfalab/core-components/link');
var bemReactClassname = require('bem-react-classname');
var cn = require('../../cn.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент копирайта: отображает данные о лицензии Альфа-Банка.
 */
var Copyright = /** @class */ (function (_super) {
    tslib.__extends(Copyright, _super);
    function Copyright() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('copyright');
        return _this;
    }
    Copyright.prototype.render = function () {
        var _a = this.props, id = _a.id, children = _a.children;
        return (React__default.default.createElement("div", { className: this.cn(), id: id, "data-test-id": this.props['data-test-id'] }, children || this.renderDefaultCopyright()));
    };
    Copyright.prototype.renderDefaultCopyright = function () {
        var _a = this.props, showYears = _a.showYears, theme = _a.theme, target = _a.target;
        var getCurrentYear = new Date().getFullYear();
        return (React__default.default.createElement("span", null,
            showYears && (React__default.default.createElement("span", { className: this.cn('years') },
                this.renderCopyrightSymbol(),
                ' ', "2001\u2014".concat(getCurrentYear, " "),
                React__default.default.createElement(link.Link, { className: this.cn({ theme: theme }), href: "https://alfabank.ru/", colors: theme === 'alfa-on-color' ? 'inverted' : 'default', target: target }, "\u0410\u043B\u044C\u0444\u0430-\u0411\u0430\u043D\u043A"),
                ".",
                ' ')),
            React__default.default.createElement("span", null, "\u0413\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u0430\u044F\u00A0\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u044F\u00A0\u0426\u0411\u00A0\u0420\u0424\u00A0\u21161326.")));
    };
    Copyright.prototype.renderCopyrightSymbol = function () {
        var copyrightSymbolProps = {
            className: this.cn('symbol'),
            'data-version': '',
        };
        var version = this.props.version;
        if (version) {
            copyrightSymbolProps['data-version'] = version;
        }
        return (React__default.default.createElement("span", tslib.__assign({ role: "img", "aria-label": "Copyright" }, copyrightSymbolProps), "\u00A9"));
    };
    Copyright.defaultProps = {
        showYears: true,
        target: '_self',
    };
    return Copyright;
}(React__default.default.PureComponent));
var Copyright$1 = cn.withTheme(Copyright);

exports.Copyright = Copyright;
exports.default = Copyright$1;
